import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import PageSeo from "@/components/feature/PageSeo";
import HeroSection from "./components/HeroSection";
import FocusStrip from "./components/FocusStrip";
import HotGrid from "./components/HotGrid";
import ChannelNav from "./components/ChannelNav";
import RankingBoard from "./components/RankingBoard";
import FaqSection from "./components/FaqSection";
import { articles } from "@/mocks/news";
import type { Article } from "@/types/news";

const list = articles as Article[];

function byTime(a: Article, b: Article) {
  return b.publishedAt.localeCompare(a.publishedAt);
}

export default function Home() {
  const sorted = [...list].sort(byTime);
  const featured = sorted[0];
  const latest = sorted.slice(1, 7);
  const hotItems = [...list].filter((item) => item.hot).concat(list.filter((item) => !item.hot)).slice(0, 6);
  const ranked = [...list].sort((a, b) => b.views - a.views).slice(0, 6);
  const picks = list.filter((item) => item.editorPick).slice(0, 4);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "爆料官网",
      url: "https://byfju.cn/",
      description:
        "爆料官网今日发布频道，聚合头条新闻、最新动态、焦点信息与今日聚焦内容。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://byfju.cn/channel/all?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "爆料官网",
      url: "https://byfju.cn/",
      email: "tips@baoliao-today.example.com",
      description: "专注娱乐爆料与热点资讯的中文资讯站，坚持多方核实、标注信源。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日发布头条",
      itemListElement: hotItems.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `https://byfju.cn/article/${item.id}`,
        name: item.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "爆料官网的「今日发布」内容多久更新一次？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "今日发布频道每天固定更新两次，分别在上午 08:00 与晚间 20:00 前后，遇到重大事件时会增设临时更新。",
          },
        },
        {
          "@type": "Question",
          name: "网站上的爆料内容都经过核实吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "编辑部对每条内容执行至少两个独立信源的交叉核对，并在正文中标注信息来源类型。",
          },
        },
        {
          "@type": "Question",
          name: "如果内容与事实不符，可以申请更正吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "当事方可通过页面底部邮箱提交更正申请，编辑部会在三个工作日内完成复核并作出处理。",
          },
        },
      ],
    },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <PageSeo
        title="爆料官网 | 今日发布·头条新闻与最新动态聚焦"
        description="爆料官网今日发布频道，聚合头条新闻、最新动态、焦点信息与今日聚焦内容，覆盖娱乐爆料、明星动态、影视综艺与网络热议，一手热闻抢先看。"
        keywords="爆料官网,今日发布,头条新闻,最新动态,焦点信息,今日聚焦"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <SiteHeader brandAsHeading />
      <main className="flex-1">
        <HeroSection featured={featured} latest={latest} />
        <FocusStrip />
        <HotGrid items={hotItems} />
        <ChannelNav />
        <RankingBoard ranked={ranked} picks={picks} />
        <FaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}